import type { CarouselImage } from '../types/content'

export const carouselImages: CarouselImage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/wPFpAcBc5M9hhfJggbjLYB/Captura_de_pantalla_2026-09-22_211329.png',
    alt: 'System page: Better corners start before the corner — the 7-step see, brake, release, lean, look, turn, exit sequence',
    caption: 'Cornering sequence',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/81tbXsGooMngdYiMxaJmtv/Captura_de_pantalla_2026-09-22_211245.png',
    alt: 'System page: One corner changes the next one — linking two corners and thinking two turns ahead',
    caption: 'Linked corners',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6E1SSGkEWUqaLotYn4dETE/Captura_de_pantalla_2026-09-22_211223.png',
    alt: 'System page: Know which end of the bike is losing grip — front-wheel vs rear-wheel traction loss diagnosis',
    caption: 'Traction diagnosis',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qdWmzfn7JdF2WthTsqRCAg/Captura_de_pantalla_2026-09-22_211147.png',
    alt: 'System page: Three lines, three different consequences — wide, middle and tight line choice',
    caption: 'Line choice',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qXvnAz2SNgNCMqeupGDgS5/Captura_de_pantalla_2026-09-22_211121.png',
    alt: 'System page: Drill 02 — Control the entry, own the exit, with braking zone, release, turn and exit target',
    caption: 'Drill 02',
  },
]
